function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { InputAdapter as Input, CheckboxAdapter as Checkbox, CheckboxGroupAdapter as CheckboxGroup, RadioAdapter as Radio, RadioGroupAdapter as RadioGroup, DropdownAdapter as Dropdown, DropdownItemAdapter as DropdownItem, DatePickerAdapter as DatePicker } from './Adapters';

var checkForRenderer = function checkForRenderer(_ref) {
  var children = _ref.children,
      component = _ref.component,
      render = _ref.render;

  if (!children && !render && !component) {
    return new Error("One of props 'children', 'render' or 'component' must be specified in '<Form />'.");
  }

  if (children && render || children && component || component && render) {
    return new Error("Only one of props 'children', 'render' or 'component' should be specified in '<Form />'.");
  }

  return null;
};

Form.propTypes = {
  /** Can be used to define form */
  children: checkForRenderer,

  /** Can be used to define form */
  render: checkForRenderer,

  /** Can be used to define form */
  component: checkForRenderer,

  /** Function to handle form submission */
  onSubmit: PropTypes.func.isRequired
};
Form.Field = Field;

Form.Input = function (props) {
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    component: Input
  }));
};

Form.Input.displayName = 'Input';

Form.Range = function (props) {
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    component: Input,
    type: "range"
  }));
};

Form.Range.displayName = 'Range';

Form.DatePicker = function (props) {
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    component: DatePicker
  }));
};

Form.DatePicker.displayName = 'DatePicker';

Form.TextArea = function (props) {
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    component: "textarea"
  }));
};

Form.TextArea.displayName = 'TextArea';

Form.Checkbox = function (props) {
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    component: Checkbox
  }));
};

Form.Checkbox.displayName = 'Checkbox';

Form.Radio = function (props) {
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    component: Radio,
    type: "radio"
  }));
};

Form.Radio.displayName = 'Radio';

Form.CheckboxGroup = function (props) {
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    component: CheckboxGroup
  }));
};

Form.CheckboxGroup.displayName = 'CheckboxGroup';

Form.RadioGroup = function (props) {
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    component: RadioGroup
  }));
};

Form.RadioGroup.displayName = 'RadioGroup';

Form.Select = function (props) {
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    component: Dropdown
  }));
};

Form.Select.displayName = 'Select';

Form.Option = function (props) {
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    component: DropdownItem
  }));
};

Form.Option.displayName = 'Option';
export default Form;